var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#00ff40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.273 18.07h4.922v2.11H5.273v-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.07 12.797H3.164A3.168 3.168 0 0 0 0 15.96v16.875A3.168 3.168 0 0 0 3.164 36H27.07a3.168 3.168 0 0 0 3.164-3.164V15.96a3.168 3.168 0 0 0-3.164-3.164ZM3.164 17.016c0-.583.472-1.055 1.055-1.055h7.031c.582 0 1.055.472 1.055 1.055v4.218c0 .583-.473 1.055-1.055 1.055H4.219a1.055 1.055 0 0 1-1.055-1.055v-4.218Zm1.055 9.492h2.11a1.055 1.055 0 0 1 0 2.11h-2.11a1.055 1.055 0 0 1 0-2.11Zm7.031 6.328H4.219a1.055 1.055 0 1 1 0-2.11h7.031a1.055 1.055 0 1 1 0 2.11Zm1.406-4.219h-2.11a1.055 1.055 0 1 1 0-2.11h2.11a1.055 1.055 0 1 1 0 2.11Zm6.328 0h-2.109a1.055 1.055 0 1 1 0-2.11h2.11a1.055 1.055 0 0 1 0 2.11Zm7.032-6.328H22.5a1.055 1.055 0 0 1 0-2.11h3.516a1.055 1.055 0 1 1 0 2.11Zm0-4.219H22.5a1.055 1.055 0 1 1 0-2.11h3.516a1.055 1.055 0 0 1 0 2.11ZM35.892 18.645l-2.093-7.81-3.522.944a5.267 5.267 0 0 1 2.067 4.182v6.91l1.31-.35a3.168 3.168 0 0 0 2.238-3.876ZM26.2 10.688l7.053-1.89-.546-2.038-14.657 3.928h8.15ZM2.459 10.688H9.9l22.261-5.965-.637-2.378A3.167 3.167 0 0 0 27.65.108L4.557 6.296A3.168 3.168 0 0 0 2.32 10.17l.139.517Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurseIcon);
export default __webpack_public_path__ + "static/media/purse-icon.a4a75ff5101062baa8796df30b465279.svg";
export { ForwardRef as ReactComponent };